module.exports = __webpack_public_path__ + "img/metal_p@2x.fe99f201.png";